import { useCallback } from 'react';
import { getLessonImage } from 'api/services/lesson-service';
import useWorkspaceApiCall from 'hooks/useWorkspaceApiCall';
import { IGetLessonImageRequest } from 'api/models/request/IGetLessonImageRequest';
import { Image } from "components/views/editor/models/Image";
import { getImageDimensions } from "../helpers/fileHelper";

export const useGetLessonImage = () => {
    const { callAPI, loading } = useWorkspaceApiCall<IGetLessonImageRequest, Blob>(getLessonImage);

    const fetchLessonImage = useCallback(async (imageFileId: string): Promise<Image | null> => {
        const resp = await callAPI({ imageFileId });
        const blob = resp?.data;

        if (!blob || !blob.size) return null;

        const extension = blob.type.split('/')[1] || 'png';
        const fileName = `lessonImage.${extension}`;
        const file = new File([blob], fileName, { type: blob.type });

        const dimensions = await getImageDimensions(blob);

        return {
            file,
            width: dimensions.width,
            height: dimensions.height
        };
    }, [callAPI]);

    return { fetchLessonImage, loading };
};